export const SAVE_NOTAMS = 'aerosimple/airfields/SAVE_NOTAMS';
export const SAVE_WEATHER_DATA = 'aerosimple/airfields/SAVE_WEATHER_DATA';
export const FETCH_AIRPORT_INFORMATION = 'aerosimple/airfields/FETCH_AIRPORT_INFORMATION';
export const FETCH_RUNWAY_CONDITIONS = 'aerosimple/airfields/FETCH_RUNWAY_CONDITIONS';
export const FETCH_USEFULLINKS = 'aerosimple/airfields/FETCH_USEFULLINKS';
